import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal } from '@fluentui/react/lib/Modal';
import type { IStyle } from '@fluentui/react/lib/Styling';
import {
    lazyHideAddCalendarsPane,
    AddCalendarsPane,
    lazyGetIsDialogOpen,
} from 'owa-calendar-addcalendar';

import styles from './AddCalendarsPaneRenderer.scss';

/**
 * This renderer for the 'Add Calendars' dialog
 */
const AddCalendarsPaneRenderer = observer(function AddCalendarsPaneRenderer() {
    const getIsDialogOpen = lazyGetIsDialogOpen.tryImportForRender();
    const isDialogOpen = getIsDialogOpen ? getIsDialogOpen() : false;

    const modalMainStyles: IStyle = {
        backgroundColor: 'transparent',
    };

    return (
        <Modal
            isOpen={isDialogOpen}
            onDismiss={onDismissAddCalendars}
            isBlocking={false}
            containerClassName={styles.dialog}
            styles={{ main: modalMainStyles }}>
            <AddCalendarsPane />
        </Modal>
    );
});
export default AddCalendarsPaneRenderer;

function onDismissAddCalendars(): void {
    lazyHideAddCalendarsPane.importAndExecute();
}
